import React from 'react';
import { Icon } from '@groupby/ui-components';
import { StyledFormControlLabel, StyledListItem, StyledListItemCheckbox } from './table-customize-view.styles';
import { Button } from '@/components/button';
export const CustomizeViewListItem = ({ item, onDrag, checked, onCheck, isDraggable, }) => {
    const handleDrag = (e) => {
        e.stopPropagation();
        if (isDraggable) {
            onDrag(item, e, { draggable: true });
        }
        else {
            onDrag(item, e, { draggable: false });
        }
    };
    const handleCheck = (e) => {
        onCheck(item, e.target.checked);
    };
    return (<StyledListItem>
      <Button onMouseDown={handleDrag} disabled={!isDraggable} icon={<Icon variant="drag"/>}/>
      <StyledFormControlLabel control={<StyledListItemCheckbox className="checkbox" disabled={item.static} checked={checked} onChange={handleCheck}/>} label={item.label}/>
    </StyledListItem>);
};
